<ul nz-menu nzMode="horizontal" style="margin-bottom: 10px;">
    <li nz-menu-item nzTitle="partner" routerLink="/whitelist/partner" [nzSelected]="currentUrl === '/whitelist/partner'">
      Partner/AR Library Whitelist
    </li>
    <li nz-menu-item nzTitle="game" routerLink="/whitelist/game"  [nzSelected]="currentUrl === '/whitelist/game'">
       AE Game Whitelist
    </li>
</ul>

<router-outlet></router-outlet>